import type * as React from "react";
import { useState } from "react";

import {styled, TextField, type TextFieldProps, Box, IconButton} from "~/common/mui";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export interface PasswordInputProps extends Omit<TextFieldProps, "variant"> {
  isHighlight?: boolean;
  helperLabel?: React.ReactNode;
  shrink?: boolean;
}

const StyledWrapper = styled(Box)({
  position: "relative",
  "& input": {
    cursor: "auto",
  },
  width: "100%",
});

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const { value, onChange, inputRef, name, ...inputProps } = props;

  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <StyledWrapper>
      <TextField
        fullWidth
        value={value}
        onChange={onChange}
        name={name}
        inputRef={inputRef}
        type={showPassword ? "text" : "password"}
        helperText={inputProps.helperLabel}
        InputLabelProps={{ shrink: inputProps.shrink }}
        InputProps={{
          endAdornment: (
            <IconButton disabled={inputProps.disabled} onClick={toggleShowPassword} color={"primary"}>
              {showPassword ? <VisibilityOffIcon /> :  <VisibilityIcon />}
            </IconButton>
          ),
        }}
        {...inputProps}
      />
    </StyledWrapper>
  );
};

export default PasswordInput;
